(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/poy-table/assets/javascripts/poy-table-scrollable.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/poy-table/assets/javascripts/poy-table-scrollable.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useRef = _React.useRef,
  useState = _React.useState,
  useContext = _React.useContext,
  createContext = _React.createContext;
const _svs$ui$reactTable = svs.ui.reactTable,
  Table = _svs$ui$reactTable.Table,
  TableHead = _svs$ui$reactTable.TableHead,
  TableRow = _svs$ui$reactTable.TableRow,
  TableHeader = _svs$ui$reactTable.TableHeader,
  TableBody = _svs$ui$reactTable.TableBody,
  TableCell = _svs$ui$reactTable.TableCell;
const _ReactWindow = ReactWindow,
  FixedSizeList = _ReactWindow.FixedSizeList;
const ROW_HEIGHT = 48;
const PoyTableContext = createContext({
  top: 0
});
const Inner = _ref => {
  let children = _ref.children;
  const _useContext = useContext(PoyTableContext),
    top = _useContext.top;
  return React.createElement(Table, {
    "aria-labelledby": "poy-ranking-header",
    className: "poy-table poy-table-scrollable f-content",
    large: true,
    style: {
      top
    }
  }, React.createElement(TableBody, null, children));
};
const Row = _ref2 => {
  let index = _ref2.index,
    data = _ref2.data;
  const player = data[index];
  return React.createElement(TableRow, {
    className: player.rankingPos % 2 !== 0 ? 'odd' : '',
    key: player.rankingPos
  }, React.createElement(TableCell, null, player.rankingPos), React.createElement(TableCell, null, player.name), React.createElement(TableCell, null, player.value));
};
const PoyTableScrollable = _ref3 => {
  let numberOfPlayers = _ref3.numberOfPlayers,
    playerList = _ref3.playerList,
    _ref3$isNameSearch = _ref3.isNameSearch,
    isNameSearch = _ref3$isNameSearch === void 0 ? false : _ref3$isNameSearch,
    searchString = _ref3.searchString;
  const listRef = useRef();
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    top = _useState2[0],
    setTop = _useState2[1];
  if (!playerList.length) {
    const noDataText = isNameSearch ? "Hittar inget som matchar din s\xF6kning \"".concat(searchString, "\"") : 'Hittar ingen rankinglista';
    return React.createElement("p", {
      className: "h3 f-content f-content-inverted"
    }, noDataText);
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "scrollable-table-header-container"
  }, React.createElement(Table, {
    "aria-labelledby": "poy-ranking-header",
    className: "poy-table f-content",
    large: true
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableHeader, {
    role: "columnheader",
    scope: "col"
  }, "Position"), React.createElement(TableHeader, {
    role: "columnheader",
    scope: "col"
  }, "Deltagare", numberOfPlayers && " (".concat(numberOfPlayers, " st)")), React.createElement(TableHeader, {
    role: "columnheader",
    scope: "col"
  }, "Po\xE4ng"))))), React.createElement(PoyTableContext.Provider, {
    value: {
      top
    }
  }, React.createElement(FixedSizeList, {
    height: ROW_HEIGHT * 10,
    innerElementType: Inner,
    itemCount: playerList.length,
    itemData: playerList,
    itemSize: ROW_HEIGHT,
    onItemsRendered: _ref4 => {
      var _listRef$current;
      let overscanStartIndex = _ref4.overscanStartIndex;
      const style = (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current._getItemStyle(overscanStartIndex);
      const offset = style && style.top || 0;
      setTop(offset);
    },
    ref: el => listRef.current = el,
    width: "100%"
  }, Row)));
};
setGlobal('svs.poker_react.components.PoyTableScrollable', PoyTableScrollable);

 })(window);